<script>
  import { createEventDispatcher, onMount } from 'svelte';
  import { getApiUrl } from '../api';
  import { authFetch } from '../authService';

  export let showModal = false;
  export let promotionId;

  const dispatch = createEventDispatcher();
  
  let formulas = [];
  let isLoading = false;
  
  // New Formula State
  let minSpending = 0;
  let maxSpending = 999999;
  let isFixedReward = false;
  let fixedRewardAmount = 0;
  let multiplier = 0;
  let maxRewardAmount = 0;
  let unit = 'Cash';
  let remarks = '';

  $: if (showModal && promotionId) {
      fetchFormulas();
  }

  async function fetchFormulas() {
      isLoading = true;
      try {
          const res = await authFetch(getApiUrl(`/promotions/formulas?promotionId=${promotionId}`));
          if (res.ok) formulas = await res.json();
      } catch(e) { console.error(e); }
      finally { isLoading = false; }
  }

  async function addFormula() {
      const payload = {
          promotionId, minSpending, maxSpending, isFixedReward, 
          fixedRewardAmount, multiplier, maxRewardAmount, unit, remarks
      };
      
      try {
          const res = await authFetch(getApiUrl('/promotions/formulas'), {
              method: 'POST',
              body: JSON.stringify(payload)
          });
          if(res.ok) {
              fetchFormulas();
              // Reset form slightly but keep useful defaults
              minSpending = maxSpending + 1; // Auto-increment range suggestion?
              maxSpending = 999999;
          }
      } catch(e) { alert(e.message); }
  }

  async function deleteFormula(id) {
      if(!confirm("Delete rule?")) return;
      await authFetch(getApiUrl(`/promotions/formulas/${id}`), { method: 'DELETE' });
      fetchFormulas();
  }

  function close() { dispatch('close'); }
</script>

{#if showModal}
<div class="modal-backdrop" on:click={close}>
    <div class="modal-content" on:click|stopPropagation>
        <h3>Manage Reward Formulas</h3>
        
        <div class="list-area">
            {#if isLoading}<p>Loading...</p>
            {:else if formulas.length === 0}<p>No formulas defined.</p>
            {:else}
                <table>
                    <thead><tr><th>Range</th><th>Reward</th><th>Cap</th><th>Action</th></tr></thead>
                    <tbody>
                        {#each formulas as f}
                            <tr>
                                <td>{f.minSpending} - {f.maxSpending}</td>
                                <td>
                                    {#if f.isFixedReward} {f.fixedRewardAmount} {f.unit}
                                    {:else} {f.multiplier}% ({f.unit})
                                    {/if}
                                </td>
                                <td>{f.isFixedReward ? '-' : f.maxRewardAmount}</td>
                                <td><button class="del" on:click={() => deleteFormula(f._id)}>X</button></td>
                            </tr>
                        {/each}
                    </tbody>
                </table>
            {/if}
        </div>

        <div class="add-form">
            <h4>Add New Rule</h4>
            <div class="row">
                <div class="g"><label>Min Spend</label><input type="number" bind:value={minSpending}></div>
                <div class="g"><label>Max Spend</label><input type="number" bind:value={maxSpending}></div>
            </div>
            <div class="row">
                <div class="g"><label>Type</label>
                    <select bind:value={isFixedReward}>
                        <option value={false}>Percentage</option>
                        <option value={true}>Fixed Amount</option>
                    </select>
                </div>
                <div class="g"><label>Unit</label><input type="text" bind:value={unit} placeholder="Cash/Miles"></div>
            </div>
            
            {#if isFixedReward}
                 <div class="g"><label>Fixed Amount</label><input type="number" bind:value={fixedRewardAmount}></div>
            {:else}
                 <div class="row">
                    <div class="g"><label>Multiplier (%)</label><input type="number" step="0.01" bind:value={multiplier} placeholder="e.g 0.4"></div>
                    <div class="g"><label>Max Reward</label><input type="number" bind:value={maxRewardAmount}></div>
                 </div>
            {/if}
            
            <div class="g"><label>Remarks</label><input type="text" bind:value={remarks}></div>
            
            <button class="add-btn" on:click={addFormula}>Add Rule</button>
        </div>

        <button class="close-btn" on:click={close}>Done</button>
    </div>
</div>
{/if}

<style>
    .modal-backdrop { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); display: flex; justify-content: center; align-items: center; z-index: 2000; }
    .modal-content { background: white; padding: 1.5rem; border-radius: 8px; width: 95%; max-width: 600px; max-height: 90vh; overflow-y: auto; }
    h3 { margin-top: 0; }
    .list-area { margin-bottom: 1.5rem; max-height: 200px; overflow-y: auto; border: 1px solid #eee; }
    table { width: 100%; border-collapse: collapse; font-size: 0.9rem; }
    th, td { padding: 8px; border-bottom: 1px solid #f0f0f0; text-align: left; }
    th { background: #f9f9f9; position: sticky; top: 0; }
    .del { background: #dc3545; color: white; border: none; border-radius: 4px; padding: 2px 6px; cursor: pointer; }
    
    .add-form { background: #f8f9fa; padding: 1rem; border-radius: 8px; border: 1px solid #eee; }
    .row { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
    .g { margin-bottom: 0.5rem; }
    label { display: block; font-size: 0.85rem; font-weight: bold; margin-bottom: 2px; }
    input, select { width: 100%; padding: 0.4rem; border: 1px solid #ccc; border-radius: 4px; box-sizing: border-box; }
    
    .add-btn { width: 100%; background: #28a745; color: white; border: none; padding: 0.6rem; border-radius: 4px; cursor: pointer; margin-top: 0.5rem; }
    .close-btn { margin-top: 1rem; width: 100%; padding: 0.6rem; background: #6c757d; color: white; border: none; border-radius: 4px; cursor: pointer; }
</style>
